var parent = require('../../../es/string/virtual/blink');

module.exports = parent;
